<template>
  <div class="stepper stepper-pills stepper-column d-flex flex-column" id="kt_stepper_example_vertical">
    <div class="row">
      <div :class="note ? 'col-12 col-md-3 col-lg-3' : 'col-12 col-md-4 col-lg-4'">
        <div class="card shadow-sm mb-8">
          <div v-if="eventName" class="card-header">
            <div class="card-title">
              <h3 class="card-label text-uppercase">{{ eventName }}</h3>
            </div>
          </div>
          <div class="card-body">
            <StepperNav
              v-if="showNav"
              :step-count="steps"
              :activeStep="activeStep"
            />
          </div>
        </div>
      </div> 

      <div v-if="note" class="col-12 col-md-3 col-lg-3 mobile_div mb-8">
        <div class="card shadow-sm">
          <div v-if="note" class="card-header">
            <div class="card-title">
              <h1 class="card-label text-uppercase fw-bolder">{{ $t('events.forms.infos') }}</h1>
            </div>
          </div>
          <div class="card-body">
            <div class="fs-6 text-gray-700 pe-7" v-html="note"></div>
          </div>
        </div>
      </div>

      <div class="mb-5" :class="note ? 'col-12 col-md-6 col-lg-6' : 'col-12 col-md-8 col-lg-8'">
        <slot name="note"/>
        <div class="card shadow-sm">
          <div class="card-header">
            <div class="card-title">
              <h3 class="card-label text-uppercase">{{ steps[activeStep-1] }}</h3>
            </div>
          </div>
          <div class="card-body">
            <StepperItem v-for="(slotContent, index) in steps" :key="index" class="step-item" :class="{ 'active': index + 1 === activeStep }">
              <form @submit.prevent="submitForm">
                <slot :name="'step' + (index + 1)" />
              </form>
            </StepperItem>
            <div class="d-flex justify-content-end" v-if="activeStep == stepCount">
              <Recaptcha />
            </div>
          </div>
          <div v-if="showNavigation" class="card-footer">
            <StepperNavigation
                v-if="showNavigation"
                :step-count="stepCount"
                :activeStep="activeStep"
                @nextStep="nextStep"
                @prevStep="prevStep"
                @handleFinish="handleFinish"
                :processing="processing"
            />
          </div>
        </div>
      </div>

      <div v-if="note" class="col-12 col-md-3 col-lg-3 web_div">
        <div class="card shadow-sm">
          <div v-if="note" class="card-header">
            <div class="card-title">
              <h1 class="card-label text-uppercase fw-bolder">{{ $t('events.forms.infos') }}</h1>
            </div>
          </div>
          <div class="card-body">
            <div class="fs-6 text-gray-700 pe-7" v-html="note"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed, ref} from "vue";
import StepperNavigation from "./StepperNavigation.vue";
import StepperItem from "./StepperItem.vue";
import StepperNav from "./StepperNav.vue";
import Recaptcha from "@/components/Recaptcha.vue"

const props = defineProps({
  id: { type: String, required: true },
  steps: { type: [Number, Array], required: true },
  showNav: { type: Boolean, default: true },
  showNavigation: { type: Boolean, default: true },
  handleFinish: Function,
  eventName: { type: String, default: '' },
  processing: { type: Boolean, default: false },
  note: { type: String, default: ''},
})

const activeStep = ref(1);

const stepCount = computed(() => Array.isArray(props.steps) ? props.steps.length : props.steps)

const nextStep = () => {
  if (activeStep.value < stepCount.value) {
    activeStep.value++;
  }
};

const prevStep = () => {
  if (activeStep.value > 1) {
    activeStep.value--;
  }
};

const reset = () => {
  activeStep.value = 1
}

const submitForm = (e) => {
  e.preventDefault()
  if (activeStep.value < stepCount.value) {
    nextStep()
  }else {
    e.preventDefault()
    props.handleFinish()
  }
}

defineExpose({
  nextStep,
  prevStep,
  reset,
  activeStep
});

</script>

<style scoped>
.step {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.step-item {
  display: none;
}

.step-item.active {
  display: block;
}

.web_div {
  display: block !important;
}

.mobile_div {
  display: none !important;
}

@media (max-width: 768px) {
  .mobile_div {
    display: block !important;
  }

  .web_div {
    display: none !important;
  }
}

</style>
